import AboutUsModule from 'components/about-us/AboutUsModule';
import { ReactElement } from 'react';
import styles from './YouMightAlsoLikePrizeGrouping.module.css';
import EmblaCarousel from 'components/carousel2025/EmblaCarousel';
import CarouselButtons from 'components/carousel2025/CarouselButtons';
import useEmblaCarousel from 'embla-carousel-react';

interface Props {
  groupings: ReactElement[];
}

const YouMightAlsoLikePrizeGrouping = (props: Props) => {
  const emblaCarouselInfo = useEmblaCarousel({
    loop: false,
    duration: 10,
    inViewThreshold: 0.1,
  });

  return (
    <AboutUsModule background="tealGradient">
      <div className={styles.container}>
        <div className={styles.headingContainer}>
          <h2 className="aboutUsTypographyHeaderXlargeOnTeal">
            You might also like...
          </h2>
        </div>
        <EmblaCarousel
          emblaCarouselInfo={emblaCarouselInfo}
          className={styles.carousel}
          items={props.groupings.map((x, index) => (
            <div className={styles.carouselItem} key={index}>
              {x}
            </div>
          ))}
        >
          <CarouselButtons
            changeSelectedIndex={(x) =>
              x < 0
                ? emblaCarouselInfo[1]?.scrollPrev()
                : emblaCarouselInfo[1]?.scrollNext()
            }
          />
        </EmblaCarousel>
      </div>
    </AboutUsModule>
  );
};

export default YouMightAlsoLikePrizeGrouping;
